module.exports = __webpack_public_path__ + "static/media/technologies_banner.cb1ac190.jpg";